import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/other/ScrollToTop';
import DraftOrdersListPage from './pages/DraftOrdersListPage';
import DraftOrderDetailPage from './pages/DraftOrderDetailPage';

function App() {
  return (
    <HashRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<DraftOrdersListPage />} />
        <Route path="/draft-order/:orderId" element={<DraftOrderDetailPage />} />
        <Route path="/order/:orderId" element={<DraftOrderDetailPage />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
